import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AddCommentModalComponent from './../Components/AddCommentModalComponent.jsx';
import {
  modal as modalActions,
  updateJiraIssueDescription
} from './../actions';
import {
  getModalInfoByOwner,
  getModalVisibility,
  getFullPath,
  getActivePage
} from './../reducers';
import {
  annotation,
  auth,
  modals,
  storage as storageHelpers
} from './../helpers';

export const mapStateToProps = (state, ownProps) => {
  return {
    visible: (getModalVisibility(state, modals.owners.comment) &&
      localStorage.getItem(storageHelpers.USER_KEY) !== null),
    statusList: ownProps.statusList,
    ticketOverridesStatus: ownProps.ticketOverridesStatus,
    ticketStatusFunc: ownProps.ticketStatusFunc
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onHide: () => dispatch(modalActions.showAddComment(false, {})),
    onSubmit: (commentInfo) => {
      dispatch(dispatchSubmitAction(
        commentInfo,
        ownProps.addCommentAction,
        ownProps.preSubmitAction));
      dispatch(modalActions.showAddComment(false, {}));
    }
  };
};

export const dispatchSubmitAction = (commentInfo, addCommentAction, preSubmitAction) => {
  return (dispatch, getState) => {
    const state = getState();
    const modalInfo = getModalInfoByOwner(state, modals.owners.comment);
    const authToken = auth.getAuthToken();
    const routerPath = getFullPath(state);
    const activePage = getActivePage(state);

    if (preSubmitAction) {
      dispatch(preSubmitAction(modalInfo.item, modalInfo.dispatcherId));
    }
    dispatch(addCommentAction(
      modalInfo.item,
      annotation.createPayloadFromInfo(
        commentInfo, modalInfo.dispatcherId, modalInfo.dispatcherType)));

    if (authToken && commentInfo.ticket)
      dispatch(updateJiraIssueDescription(
        {
          ...commentInfo,
          item: modalInfo.item
        },
        modalInfo.position,
        authToken,
        routerPath,
        activePage));
  };
};

const AddCommentModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCommentModalComponent);

AddCommentModalContainer.propTypes = {
  addCommentAction: PropTypes.func.isRequired,
  preSubmitAction: PropTypes.func,
  statusList: PropTypes.arrayOf(
    PropTypes.shape({ displayStatus: PropTypes.string.isRequired })).isRequired,
  ticketOverridesStatus: PropTypes.bool,
  ticketStatusFunc: PropTypes.func.isRequired
};

export default AddCommentModalContainer;


// WEBPACK FOOTER //
// src/Containers/AddCommentModalContainer.jsx